import { axiosInstance } from './axiosInstance'
import { END_POINT_PRODUCT } from './index'

export const getMaterialAssemblies = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/material-assembly`,
  })
}

export const getMaterialAssembly = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/material-assembly`,
  })
}

export const deleteMaterialAssemblyRequest = (materialAssemblyId) => {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/material-assembly/${materialAssemblyId}`,
  })
}

export const updateMaterialAssembly = (materialAssembly) => {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/material-assembly`,
    data: materialAssembly,
  })
}

export const saveMaterialAssembly = (materialAssembly) => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/material-assembly`,
    data: materialAssembly,
  })
}

export const getMaterialAssemblyByProjectId = (projectId) => {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/material-assembly/${projectId}`,
  })
}

export const saveMaterialAssemblyForProject = (projectId, materialAssemblyIds) => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/material-assembly/${projectId}`,
    data: materialAssemblyIds,
  })
}

export const preloadMaterials = () => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/preload-materials`,
  })
}

export const getMaterialPricing = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/material-pricing`,
  })
}

export const createMaterialPricing = (materialPricing) => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/material-pricing`,
    data: materialPricing,
  })
}

export const updateMaterialPricing = (id, materialPricing) => {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/material-pricing/${id}`,
    data: materialPricing,
  })
}

export const deleteMaterialPricing = (id) => {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/material-pricing/${id}`,
  })
}
